import { Link, useNavigate } from "react-router-dom";
import { clearParentJwt } from "../api/client";

interface Props {
  displayName?: string;
}

export function CabinetHeader({ displayName }: Props) {
  const navigate = useNavigate();
  function logout() {
    clearParentJwt();
    navigate("/login");
  }
  return (
    <header className="bg-white border-b border-[var(--color-ink)] sticky top-0 z-10">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 py-4 flex justify-between items-center">
        <Link to="/cabinet" className="flex gap-2 items-center">
          <img
            src="/logo-gim94.png"
            alt="Гимназия №94"
            className="w-7 h-7 object-contain"
          />
          <span className="text-xs font-bold uppercase tracking-[0.05em] text-[var(--color-ink)]">
            Гордость 94
          </span>
        </Link>
        <div className="flex items-center gap-5 text-xs">
          {displayName && (
            <span className="text-[var(--color-muted)] hidden sm:inline">
              {displayName}
            </span>
          )}
          <Link
            to="/cabinet/portfolio"
            className="text-[var(--color-ink)] no-underline border-b border-transparent hover:border-[var(--color-ink)] pb-[2px] hidden sm:inline"
          >
            Архив
          </Link>
          <Link
            to="/cabinet/profile"
            className="text-[var(--color-ink)] no-underline border-b border-transparent hover:border-[var(--color-ink)] pb-[2px]"
          >
            Профиль
          </Link>
          <button
            onClick={logout}
            className="text-[var(--color-muted)] no-underline border-b border-transparent hover:border-[var(--color-muted)] pb-[2px]"
          >
            Выйти
          </button>
        </div>
      </div>
    </header>
  );
}
